export const sanitizeElasticSearchStringValue = (value: string): string => {
  // reserved characters are:  + - = && || > < ! ( ) { } [ ] ^ " ~ * ? : \ /
  // but > and < are not escapable so they are omitted from the regex
  // " is omitted because we need exact search feature
  const reservedCharRegex = /\+|-|=|&{2}|\|{2}|!|\(|\)|{|}|\[|]|\^|~|\*|\?|:|\\|\//gm;
  return value.replace(reservedCharRegex, (reservedChar) => `\\${reservedChar}`);
};
